<template>
	<transition-group tag="div" name="entry" class="root">
		<div v-for="entry in entries" :key="entry.id" class='textContainer'>
			<span class='text'>{{entry.text}}</span>
		</div>
	</transition-group>
</template>

<script>
	import _ from "lodash";

	export default {
		name: "Log",
		props: {
			traces: {
				default: [],
			},
		},
		computed: {
			entries: function() {
				return _.chain(this.traces).orderBy((trace) => trace.id).reverse().slice(0, 5).map((trace) => {
					let from = trace.nodes[0];
					let to = trace.nodes[trace.nodes.length - 1];
					let text = "";
					if (from.city) {
						text += from.city + ", ";
					}
					if (from.subdivision) {
						text += from.subdivision + ", ";
					}
					text += from.country + " -> ";
					if (to.city) {
						text += to.city + ", ";
					}
					if (to.subdivision) {
						text += to.subdivision + ", ";
					}
					text += to.country;
					return {
						id: trace.id,
						text: text,
					};
				}).value();
			},
		}
	}
</script>

<style scoped>
	.root {
		position: absolute;
		left: 42px;
		bottom: 42px;
		right: 42px;
		/*width: 500px;*/
		z-index: 1;

		font-family: 'Roboto Mono', sans-serif;
		font-size: 14px;
		text-align: center;
		color: #ffffff;
		opacity: 0.6;

		/*border: 1px solid #ffffff;*/
		/*border-top: 2px solid #f26721;*/
		/*padding-top: 6px;*/
	}

	.textContainer {
		height: 19px;
		overflow: visible;
	}

	.text {
		height: 19px;
	}

	.entry-enter-active, .entry-leave-active {
		transition: all 0.3s;
	}

	.entry-enter {
		opacity: 0;
	}

	.entry-leave-to {
		height: 0;
		opacity: 0;
	}
</style>